<template>
  <div id="app">
    <!-- 登录页面 -->
    <router-view v-if="$route.path === '/login'"/>
    
    <!-- 主应用布局 -->
    <el-container v-else style="height: 100vh">
      <!-- 侧边栏 -->
      <el-aside width="200px" style="background-color: #304156">
        <div class="logo">
          <h3 style="color: white; text-align: center; padding: 20px 0">管理后台</h3>
        </div>
        <el-menu
          :default-active="$route.path"
          router
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF">
          <!-- 学生 -->
          <el-menu-item index="/student">
            <i class="el-icon-user"></i>
            <span slot="title">学生</span>
          </el-menu-item>
          
          <!-- 学校 -->
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-school"></i>
              <span>学校</span>
            </template>
            <el-menu-item index="/college/list">学校</el-menu-item>
          </el-submenu>
          
          <!-- 课程 -->
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-reading"></i>
              <span>课程</span>
            </template>
            <el-menu-item index="/course/list">课程列表</el-menu-item>
          </el-submenu>
          
          <!-- 作业 -->
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-edit"></i>
              <span>作业</span>
            </template>
            <el-menu-item index="/homework/list">作业列表</el-menu-item>
            <el-menu-item index="/homework/answer">学生答案</el-menu-item>
          </el-submenu>
          
          <!-- 班级 -->
          <el-menu-item index="/class">
            <i class="el-icon-s-home"></i>
            <span slot="title">班级</span>
          </el-menu-item>
          
          <!-- 字典管理 -->
          <el-menu-item index="/dict">
            <i class="el-icon-s-operation"></i>
            <span slot="title">字典管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      
      <!-- 主内容区 -->
      <el-container>
        <!-- 顶部导航栏 -->
        <el-header style="background-color: #fff; border-bottom: 1px solid #e6e6e6; display: flex; justify-content: space-between; align-items: center;">
          <div></div>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-user-solid"></i>
              {{ username }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">
                <i class="el-icon-setting"></i>
                个人中心
              </el-dropdown-item>
              <el-dropdown-item command="logout" divided>
                <i class="el-icon-switch-button"></i>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-header>
        
        <!-- 主内容 -->
        <el-main style="background-color: #f0f2f5; padding: 0">
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      username: localStorage.getItem('admin_username') || 'admin'
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'profile') {
        this.$router.push('/profile')
      } else if (command === 'logout') {
        this.$confirm('确定要退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('admin_token')
          localStorage.removeItem('admin_username')
          this.$message.success('已退出登录')
          this.$router.push('/login')
        }).catch(() => {})
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  font-size: 14px;
}
.el-dropdown-link:hover {
  color: #66b1ff;
}
</style>
